<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Trick Questions
              <p class="category" style="text-transform:none;">
                Crie aqui suas perguntas "armadilha"
              </p>
            </h4>
            <div class="d-flex align-items-center">
              <button
                class="btn btn-info btn-sm"
                @click="visibilityStates.addVisibility = true"
              >
                Adicionar Trick Question
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-left">Id</th>
                  <th>Nome</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dt in tricks" :key="dt.id">
                  <td>{{ dt.id }}</td>
                  <td>{{ dt.text }}</td>
                  <td class="text-right">
                    <ActionButtons
                      :itemId="dt.id"
                      itemType="trickId"
                      @openDeleteModal="openDeleteModal"
                      @openEditModal="openEditModal"
                    ></ActionButtons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ListLoader v-if="loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!loading && error"></Error>
          <Empty v-if="!loading && !error && tricks.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Add -->
    <Modal
      v-model="visibilityStates.addVisibility"
      successMessage="Trick criada com sucesso!"
      action="Salvar"
      title="Adicionar Trick Question"
      @closeModal="clear()"
      @confirmAction="updateQuestion()"
    >
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label class="d-block">Tipo da Trick Question</label>
            <select v-model="trick.type">
              <option value="know">Conhece</option>
              <option value="nps">NPS</option>
              <option value="classes">Like & Dislike</option>
              <option value="comment">Comentário</option>
            </select>
          </div>
          <div class="form-group">
            <label>Pergunta</label>
            <textarea class="form-control" v-model="trick.text"></textarea>
          </div>
        </div>
      </template>
    </Modal>

    <!-- Modal Delete -->
    <Modal
      v-model="visibilityStates.deleteVisibility"
      successMessage="Trick Question excluída com sucesso!"
      action="Excluir"
      :name="trick.text"
      title="Excluir Trick Question"
      @closeModal="clear()"
      @confirmAction="removeTrick(trick.id)"
    >
      <template v-slot:body>
        <p>
          Tem certeza que deseja excluir a trick selecionada?
        </p>
      </template>
    </Modal>

    <!-- Edit -->
    <Modal
      v-model="visibilityStates.editVisibility"
      successMessage="Trick atualizada com sucesso!"
      action="Atualizar"
      :name="trick.text"
      title="Editar Trick Question"
      @closeModal="clear()"
      @confirmAction="updateQuestion()"
    >
      <template v-slot:body>
        <div>
          <div class="form-group">
            <label class="d-block">Tipo da Trick Question</label>
            <select v-model="trick.trickLocation">
              <option value="know">Conhece</option>
              <option value="nps">NPS</option>
              <option value="classes">Like & Dislike</option>
              <option value="comment">Comentário</option>
            </select>
          </div>
          <div class="form-group">
            <label>Pergunta</label>
            <textarea class="form-control" v-model="trick.text"></textarea>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card";
import Modal from "@/components/Modal/Modal";
import { RepositoryFactory } from "../RepositoryFactory";
const tricks = new RepositoryFactory("tricks");
export default {
  components: {
    Modal,
    Card
  },
  data() {
    return {
      // All Tricks
      tricks: [],

      // Single Trick
      trick: {
        id: null,
        type: "",
        trickLocation: "",
        text: ""
      },

      // Modal States
      visibilityStates: {
        addVisibility: false,
        editVisibility: false,
        deleteVisibility: false
      },

      // Actions States
      loading: false,
      error: false
    };
  },
  created() {
    this.loadTricks();
  },
  methods: {
    openEditModal(params) {
      this.visibilityStates.editVisibility = params.state;
      this.loadTrick(params.trickId);
    },
    openDeleteModal(params) {
      this.visibilityStates.deleteVisibility = params.state;
      this.loadTrick(params.trickId);
    },
    clear() {
      Object.assign(this.$data.trick, this.$options.data().trick);
      Object.assign(
        this.$data.visibilityStates,
        this.$options.data().visibilityStates
      );
    },
    async loadTrick(trickId) {
      const { data } = await tricks.getById(trickId);
      this.trick.id = data.id;
      this.trick.name = data.name;
    },
    async loadTricks() {
      this.loading = true;
      try {
        const { data } = await tricks.get();
        this.tricks = data;
      } catch (error) {
        this.error = true;
      }
      this.loading = false;
    },
    async removeTrick(trickId) {
      try {
        await tricks.delete(trickId);
      } catch (error) {}
      this.clear();
    }
  }
};
</script>
<style scoped></style>
